import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { removeCaracter } from 'src/app/core/constants/properties-const';
import { UserLead } from 'src/app/core/models/lead-campaign';
import { ButtonsPopupService } from 'src/app/shared/components/buttons-popup/service/buttons-popup.service';
import { LeadCampaignService } from '../lead-campaign.service';

@Component({
  selector: 'app-participants-card',
  templateUrl: './participants-card.component.html',
  styleUrls: ['./participants-card.component.scss']
})
export class ParticipantsCardComponent implements OnInit {

  @Input() public index = 0;
  @Input() public user: UserLead;
  @Input() campaignId: number;
  @Input() participants: FormArray;
  @Input() editable: boolean;

  @Output() public removeParticipant = new EventEmitter<number>();
  @Output() public editParticipant = new EventEmitter<object>();

  public isValueError = false;
  public isRealtorError = false;
  public valueErro = 'O investimento mínimo por participante deve ser de R$ 100.';
  public removeCaracter = removeCaracter;
  public isEdit: boolean = false;
  public formCard: FormGroup;
  public deleteUser = {
    title: 'ATENÇÃO!',
    description: 'Tem certeza que deseja excluir o participante dessa campanha?',
    buttons: [
      {
        btnType: 0,
        title: 'Cancelar',
        func: () => null,
      },
      {
        btnType: 2,
        title: 'Excluir',
        func: () => this.removeParticipant.emit(this.index),
      }
    ]
  };

  constructor(
    private campaignService: LeadCampaignService,
    private btnsService: ButtonsPopupService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.initialize();
  }

  private initialize(): void {
    this.formCard = this.fb.group({
      user_id: [this.user?.user_id, Validators.required],
      user_name: [this.user?.user_name, Validators.required],
      user_nickname: [this.user?.user_nickname, Validators.required],
      participation_value: [this.user?.participation_value, Validators.required],
      participation_percentage: [this.user?.participation_percentage],
      picture_url: [this.user?.picture_url],
      leaders: [this.user?.leaders]
    });

    if (!this.user?.user_nickname) {
      this.isEdit = true;
      this.isRealtorError = true;
    }
  }

  showDialog(event) {
    this.btnsService.show(this.deleteUser);
  }

  removePicture() {
    this.user.picture_url = null;
  }

  setParticipant(participant): void {
    if (!participant) {
      this.isRealtorError = true;
      return;
    }

    const matched = participant.matched_record;
    this.formCard.controls.user_id.setValue(matched.id);
    this.formCard.controls.user_name.setValue(matched.name);
    this.formCard.controls.user_nickname.setValue(matched.nickname);
    this.formCard.controls.picture_url.setValue(matched.picture_url);
    this.formCard.controls.leaders.setValue(matched.leaders);

    this.isRealtorError = false;
  }

  public submitChanges(): void {
    this.isValueError = false;
    const data = {
      participant: this.formCard.getRawValue(),
      index: this.index
    }

    const valueInvest = this.campaignService.parseCurrency(data.participant.participation_value);

    if (valueInvest < 100) {
      this.isValueError = true;
      return;
    }

    if (!data.participant.user_nickname) {
      this.isRealtorError = true;
      return;
    }

    if (!this.isValueError) {
      this.editParticipant.emit(data);
      this.closeEdit();
    }
  }

  public closeEdit(): void {
    this.initialize();
    this.isEdit = false;
    this.isValueError = false;
  }

  public validateValue(value: string): void {
    if (this.campaignService.parseCurrency(value) < 100) {
      this.isValueError = true;
      return;
    }
    this.isValueError = false;
  } 
}